@if (mode() === 'category') {
    <mat-card
        appearance="raised"
        class="app-card mat-elevation-z4"
        [ngClass]="{ 'app-card--disabled': disabled() }"
        [ngStyle]="{ backgroundColor: cardHover() ? category().backgroundAccentColor : '#31313150' }"
        matRipple
        [routerLink]="['/', homePagePath, category().category]"
        (mouseover)="cardHover.set(true)"
        (mouseleave)="cardHover.set(false)"
    >
        <mat-card-header>
            <div
                mat-card-avatar
                class="card-avatar"
                [ngStyle]="{
                    opacity: cardHover() ? 0.75 : 1,
                    backgroundColor: cardHover() ? category().backgroundAccentColor : null
                }"
                [style.background-size]="'cover'"
                [style.background-image]="categoryLogo()"
            ></div>
            <mat-card-title>
                @let titleHtml = category().category | wrapFn: sanitizeHTML;
                <span [innerHTML]="titleHtml" [style.font-weight]="400"></span>
            </mat-card-title>
            <mat-card-subtitle></mat-card-subtitle>
        </mat-card-header>
    </mat-card>
} @else if (mode() === 'app') {
    <mat-card
        appearance="raised"
        class="app-card mat-elevation-z4"
        [ngClass]="{ 'app-card--disabled': disabled() }"
        [ngStyle]="{ backgroundColor: cardHover() ? app().data?.['cardBackground'] : '#31313150' }"
        matRipple
        [routerLink]="['/' + app().path]"
        (mouseover)="cardHover.set(true)"
        (mouseleave)="cardHover.set(false)"
    >
        @if (!disabled() && !disableFavoriteToggle()) {
            <div
                class="FavoriteToggle"
                [ngClass]="{ 'FavoriteToggle--IsFavorite': favoriteApp() }"
                [matTooltip]="favoriteApp() ? 'Remove from favorite apps' : 'Add to favorite apps'"
                matTooltipPosition="above"
            >
                <button mat-icon-button (click)="_toggleFavorite($event)" class="sphere-density__compact">
                    <mat-icon>{{ favoriteApp() ? 'star' : 'star_outline' }}</mat-icon>
                </button>
            </div>
        }
        <mat-card-header>
            <div
                mat-card-avatar
                class="card-avatar"
                [ngStyle]="{
                    opacity: cardHover() ? 0.75 : 1,
                    backgroundColor: cardHover() ? app().data['cardBackground'] : null
                }"
                [style.background-size]="'cover'"
                [style.background-image]="appLogo()"
            ></div>
            @if (app().data?.alpha || app().data?.beta) {
                <div class="ExperimentalTagWrapper">
                    <sphere-experimental-tag [featureStage]="app().data.beta ? 'beta' : app().data.alpha ? 'alpha' : undefined" />
                </div>
            }
            <mat-card-title>
                @let titleHtml = appData().name | wrapFn: sanitizeHTML;
                <span [innerHTML]="titleHtml" [style.font-weight]="400"></span>
            </mat-card-title>
            <mat-card-subtitle>{{ appData().tagLine | uppercase }}</mat-card-subtitle>
        </mat-card-header>
    </mat-card>
} @else {
    <h3>Invalid home app card mode {{ mode() }}</h3>
}
